Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentLaNacionNewsTextView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents/inbox/LaNacionNews/social_content"]
  className: ''

  initialize: (options = {}) ->
    @socialContent = options.socialContent
    
  render: ->
    @$el.html @template
    this
